import { render } from "./form.vue?vue&type=template&id=1dfeb5ef&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=1dfeb5ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1dfeb5ef"

export default script